import dynamic from 'next/dynamic';
import { useCallback, useEffect, useMemo, useState } from 'react';

// The actual palette (cmdk, fuse.js, all contentlayer help articles) is heavy
// — load it as an async chunk only once the palette is first opened, instead
// of shipping it with every page.
const CmdkPanel = dynamic(() => import('./CmdkPanel'), {
  ssr: false,
  loading: () => null,
});

export default function useCMDK() {
  const [showCMDK, setShowCMDKState] = useState(false);
  const [everOpened, setEverOpened] = useState(false);

  const setShowCMDK = useCallback(value => {
    setEverOpened(true);
    setShowCMDKState(value);
  }, []);

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = e => {
      const existingModalBackdrop = document.getElementById('modal-backdrop');
      if (e.key === 'k' && (e.metaKey || e.ctrlKey) && !existingModalBackdrop) {
        e.preventDefault();
        setShowCMDK(prev => !prev);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [setShowCMDK]);

  const CMDK = useCallback(() => {
    if (!everOpened) return null;
    return <CmdkPanel showCMDK={showCMDK} setShowCMDK={setShowCMDK} />;
  }, [everOpened, showCMDK, setShowCMDK]);

  return useMemo(() => ({ showCMDK, setShowCMDK, CMDK }), [
    showCMDK,
    setShowCMDK,
    CMDK,
  ]);
}
